import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import { Alert, Box, Dialog, Typography, useMediaQuery } from "@mui/material";
import Button from "@mui/material/Button";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { AppBar, Toolbar } from "../../node_modules/@mui/material/index";
import { useError } from "../Context/ErrorContext";
import { getBannerApi } from "../axios/api";
import {
  allRoutePathsFunc,
  allSubRoutes,
  patientPortalRoutes,
} from "../constants/allRoutePaths";
import { BackNavigationContext } from "../hooks/BackNavigationContext";
import { useAxios } from "../hooks/auth";
import { usePrevLocation } from "../hooks/usePrevLocation";
import useIsPrevileges from "../hooks/useRoleAndPrivileges";
import { updateAdminPath } from "../store/slices/adminPathSlice";
import "./Layout.scss";
import MaintenanceBanner from "./MaintenanceBanner";
import NonCompliantBanner from "./NonCompliantBanner";
import UpdatePassword from "./profileComponent/UpdatePassword";
import PermanentDrawerLeft from "./sidebar";
import MobileBottomNavigation from "./sidebar/MobileBottomNavigation";

const openDrawerWidth = 240;
const collapsedDrawerWidth = 70;
function Layout({ tabPath, isPatient }) {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const isMobile = useMediaQuery("(max-width:800px)");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const prevLocation = usePrevLocation(location);
  const { userInfo, tempPassword } = useIsPrevileges();
  const [cookies] = useCookies();
  const { errorMessage } = useError();
  const [routeStack, setRouteStack] = useState([]);
  const routeStackRef = useRef([]);
  const axios = useAxios();
  const [bannerData, setBannerData] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const shouldShowPasswordDialog = !localStorage.getItem(
    "hasDismissedPasswordDialog",
  );
  const canShowDialog =
    Boolean(errorMessage) &&
    (cookies?.isPatient ? shouldShowPasswordDialog : true);
  const [showNonCompliantBanner, setShowNonCompliantBanner] = useState(true);

  useEffect(() => {
    if (
      Boolean(errorMessage) &&
      (cookies?.isPatient ? shouldShowPasswordDialog : true)
    ) {
      setShowDialog(true);
    } else {
      setShowDialog(false);
    }
  }, [errorMessage, cookies, shouldShowPasswordDialog]);

  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  useEffect(() => {
    getBannerApi(axios)
      .then((res) => {
        if (res?.showBanner === 1) {
          setBannerData(res?.message);
        } else {
          setBannerData("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    const currentPath = location.pathname;

    if (
      routeStackRef.current[routeStackRef.current.length - 1] !== currentPath
    ) {
      routeStackRef.current.push(currentPath);
      setRouteStack([...routeStackRef.current]); // Optional state update
    }
  }, [location]);

  const handleBackBtnClick = () => {
    if (location.search.includes("isnewtab")) {
      navigate("/dashboard");
    } else if (routeStackRef.current.length > 1) {
      const newStack = [...routeStackRef.current];
      newStack.pop();
      const prevRoute = newStack[newStack.length - 1];

      routeStackRef.current = newStack;
      setRouteStack(newStack);
      navigate(prevRoute);
    } else {
      navigate("/dashboard");
    }
    if (location?.pathname === "/location-view") {
      dispatch(updateAdminPath(3));
    } else if (location?.pathname === "/insurance-view") {
      dispatch(updateAdminPath(5));
    }
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  // const location = useLocation();
  const { isCollapsed } = useSelector((state) => state.sideBarCollapseSelector);

  const tabPathNew = isPatient
    ? "/patient-portal"
    : sessionStorage.getItem("patientId")
    ? ``
    : tabPath;

  const bannerFlag =
    bannerData &&
    (location?.pathname === "/dashboard" ||
      location?.pathname === "/patient-portal");

  return (
    <div className="App">
      <nav className="app__sidebar">
        {!isMobile && (
          // tabPath === "/patient-portal" ? <DesktopSidebar/> :
          <PermanentDrawerLeft
            tabPath={tabPathNew}
            email={userInfo?.email}
            tenantId={userInfo?.tenantId}
          />
        )}
      </nav>
      <main className={isMobile ? "app__contentMobile" : "app__content"}>
        <div style={{ height: "calc(100vh - 130px)" }}>
          <AppBar
            position="fixed"
            sx={{
              width: isMobile
                ? "100%"
                : isCollapsed
                ? { sm: `calc(100% - ${collapsedDrawerWidth}px)` }
                : { sm: `calc(100% - ${openDrawerWidth}px)` },
              ml: isCollapsed
                ? { sm: `${collapsedDrawerWidth}px` }
                : { sm: `${openDrawerWidth}px` },
              flexDirection: "row",
            }}
          >
            <Typography
              variant="h5"
              noWrap
              component="div"
              sx={{
                flexGrow: 1,
                display: "flex",
                paddingLeft: "24px",
                alignItems: "center",
              }}
            >
              {
                allRoutePathsFunc()
                  .concat(allSubRoutes)
                  .find((element) => element.path === location.pathname)?.text
              }
              {
                patientPortalRoutes?.find(
                  (element) => element.path === location.pathname,
                )?.text
              }
            </Typography>
            <Toolbar sx={{ alignSelf: "flex-end" }}>
              {/* <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton> */}
              <Box>
                <Typography variant="h4" noWrap component="div">
                  SleepNavigator®
                </Typography>
                {userInfo?.tenantName ? (
                  <Typography>{userInfo?.tenantName}</Typography>
                ) : (
                  ""
                )}
              </Box>
            </Toolbar>
          </AppBar>

          {bannerFlag && (
            <MaintenanceBanner
              bannerData={bannerData}
              setBannerData={setBannerData}
            />
          )}

          {userInfo?.roleId === 3 &&
            location.pathname ===
              allRoutePathsFunc().find((row) =>
                row.tabName.includes("dashboard"),
              ).path &&
            showNonCompliantBanner && (
              <NonCompliantBanner
                show={showNonCompliantBanner}
                onClose={() => setShowNonCompliantBanner(false)}
              />
            )}

          <Button
            startIcon={<KeyboardReturnIcon />}
            onClick={() => handleBackBtnClick()}
          >
            Back
          </Button>
          {errorMessage && (
            <>
              <Alert severity="error" sx={{ margin: "25px" }}>
                {" "}
                {errorMessage}
              </Alert>

              <Dialog open={showDialog}>
                <Box sx={{ padding: "10px", width: "550px" }}>
                  <UpdatePassword
                    isDialog={cookies?.isPatient}
                    handleCloseDialog={handleCloseDialog}
                  />
                </Box>
              </Dialog>
            </>
          )}

          <BackNavigationContext.Provider
            value={{
              handleBackBtnClick,
              routeStackRef,
            }}
          >
            <Outlet />
          </BackNavigationContext.Provider>
        </div>

        {isMobile && <MobileBottomNavigation />}
      </main>
    </div>
  );
}

export default Layout;
